/**
 * Deep links into TikTok's own tools.
 *
 * Some TikTok assets simply cannot be created through the Business API —
 * Instant Forms are the main one (`/page/create/`, `/pages/leadgen/create/`
 * and `/page/leadgen/create/` all 404, live-probed 2026-08-27). For those we
 * send the user straight to the right screen in TikTok instead of pretending
 * the CRM can build them.
 *
 * `aadvid` is TikTok's advertiser selector — without it the link opens on
 * whichever account the user last used, which may be the wrong one.
 */
const ADS_BASE = 'https://ads.tiktok.com';

function withAdvertiser(path: string, advertiserId?: string): string {
  const url = `${ADS_BASE}${path}`;
  return advertiserId ? `${url}?aadvid=${encodeURIComponent(advertiserId)}` : url;
}

/** Leads Center → Instant form, where lead-gen forms are created. */
export function tiktokInstantFormsUrl(advertiserId?: string): string {
  return withAdvertiser('/i18n/leads_center/instant_form', advertiserId);
}

/** Assets → Apps, for registering an app to promote. */
export function tiktokAppsUrl(advertiserId?: string): string {
  return withAdvertiser('/i18n/asset/app', advertiserId);
}

/** Events Manager, where pixel events are configured. */
export function tiktokEventsUrl(advertiserId?: string): string {
  return withAdvertiser('/i18n/events_manager', advertiserId);
}
